// Suggestions domain policy. Owns whether the assistant should generate initial
// suggested questions (ISQ) for a conversation — extracted from the common.js
// junk drawer so the ISQ eligibility rule has a named home. (Follow-up / clarifying
// suggestion policy would live here too as it is built out.)

/**
 * Decide whether initial suggested questions should be generated for a conversation.
 * Returns false once the customer has interacted or ISQ already exist on the initial
 * message; otherwise gates on the per-surface dynamic-ISQ feature flags.
 * @param {Object} params
 * @param {Array} params.savedMessages
 * @param {string} params.channel
 * @param {boolean} params.isConsumerApp
 * @param {boolean} params.isDynamicIsqMasterEnabled
 * @param {boolean} params.isDynamicIsqDtFsEnabled
 * @param {boolean} params.isDynamicIsqMwFsEnabled
 * @param {boolean} params.isDynamicIsqAppFsEnabled
 * @param {boolean} params.isDynamicIsqValidCustomerType
 * @returns {boolean}
 */
export const checkGenerateQuestionsNeeded = ({
  savedMessages,
  channel,
  isConsumerApp,
  isDynamicIsqMasterEnabled,
  isDynamicIsqDtFsEnabled,
  isDynamicIsqMwFsEnabled,
  isDynamicIsqAppFsEnabled,
  isDynamicIsqValidCustomerType
}) => {
  const isDesktop = channel === 'desktop';
  const isMobile = channel === 'mobile' && !isConsumerApp;
  const initialMessage = savedMessages.find((msg) => msg.isInitialMessage);

  const hasCustomerInteracted = savedMessages.length > 1;
  const isISQExistsForInitialMessage = initialMessage?.content?.relatedQuestions?.suggestedQuestions?.length > 0;

  if (isISQExistsForInitialMessage || hasCustomerInteracted) return false;

  // Fetch flags to determine if we should call generate questions
  const enableForDesktop = isDesktop && isDynamicIsqDtFsEnabled;
  const enableForMobile = isMobile && isDynamicIsqMwFsEnabled;
  const enableForApp = isConsumerApp && isDynamicIsqAppFsEnabled;
  const shouldCallGenerateQuestions = isDynamicIsqMasterEnabled
    && isDynamicIsqValidCustomerType
    && (enableForDesktop || enableForMobile || enableForApp);
  return shouldCallGenerateQuestions;
};
